export default __webpack_public_path__ + "static/media/graph.fc1d7dc4.svg";